import React, { useState } from 'react';
import { useTheme } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    CreateDeliveryListMutationVariables,
    DeliveryListItemCreate,
    useCreateDeliveryListMutation,
} from '../../../../generated/graphql';
import { routePaths } from '../../../../routePaths';
import { FullScreenDialog } from '../../../../ui-kit';
import { useWarehousesScope } from '../../../warehouse/providers/WarehouseScopeProvider';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { useUser } from '../../../../utils/hooks/auth';
import DeliveryListForm from './DeliveryListForm';
import { DeliveryListFormValues } from './types';

const CreateDeliveryListForm = () => {
    const [isDialogOpened, setIsDialogOpened] = useState(true);
    const { currentWarehouseId } = useWarehousesScope();
    const { user: { defaultCurrency: { currencyCode } } } = useUser();
    const { priceService } = usePriceService();
    const history = useHistory();
    const theme = useTheme();

    const onClose = () => {
        setIsDialogOpened(false);
        setTimeout(() => history.push(routePaths.warehouseDeliveryLists), theme.transitions.duration.leavingScreen);
    };

    const [runMutation] = useCreateDeliveryListMutation();
    const onSubmit = async ({ invoiceNumber, supplierId, deliveryDateUtc, deliveryListItems }: DeliveryListFormValues) => {
        const mappedDeliveryListItems: DeliveryListItemCreate[] = deliveryListItems.map(({ stockCardId, quantity, priceWithoutVat }) => {
            const { amount, precision } = priceService.parseIntegerFromFloat(priceWithoutVat);
            const finalPrice = priceService.getAmountWithPrecision(amount, precision, currencyCode);
            return {
                stockCardId,
                priceWithoutVat: finalPrice,
                quantity
            };
        });
        const variables: CreateDeliveryListMutationVariables = {
            data: {
                invoiceNumber,
                warehouseId: currentWarehouseId as string,
                deliveryDateUtc,
                deliveryListItems: mappedDeliveryListItems,
                supplierId,
            }
        };
        await runMutation({ variables });
        onClose();
    };

    const { t } = useTranslation();


    return (
        <FullScreenDialog isOpened={isDialogOpened}>
            <DeliveryListForm
                dialogName={t('New delivery list')}
                onClose={onClose}
                onSubmit={onSubmit}
            />
        </FullScreenDialog>
    );
};

export default CreateDeliveryListForm;
